<div>
    <insinv-navigation layout="horizontal"></insinv-navigation>
</div>
